// src/components/common/DescriptionBlock.js
import React from 'react';
import { Box, Typography } from '@mui/material';

// 이미지(HeroBanner overlay=false)를 깨끗하게 보여준 다음,
// 그 아래에서 제목과 설명을 검은 배경 위에 텍스트로 풀어주는 블록
const DescriptionBlock = ({ title, paragraphs = [] }) => (
  <Box
    sx={{
      backgroundColor: '#0f172a',
      color: 'white',
      p: { xs: 3, md: 5 }
    }}
  >
    {title && (
      <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
        {title}
      </Typography>
    )}
    {paragraphs.map((text, index) => (
      <Typography
        key={index}
        variant="body1"
        sx={{ color: '#D1D5DB', lineHeight: 1.8, mb: index === paragraphs.length - 1 ? 0 : 1.5 }}
      >
        {text}
      </Typography>
    ))}
  </Box>
);

export default DescriptionBlock;
